import { TiDeviceDesktop } from "@onemind-services-llc/react-icons-ng/ti";
import { BsHddNetwork } from "@onemind-services-llc/react-icons-ng/bs";
import { MdOutlineCloudDone } from "@onemind-services-llc/react-icons-ng/md";

export const ADVANTAGES_CONSTANTS = [
  {
    icon: TiDeviceDesktop,
    title: "Dedicated & Static",
    text: "Public IPs remain persistent across reboots and reconfigurations.",
  },
  {
    icon: BsHddNetwork,
    title: "Dual-Stack Support",
    text: "Run IPv4 and IPv6 concurrently for broader compatibility.",
  },
  {
    icon: MdOutlineCloudDone,
    title: "Cloud & Bare-Metal Ready",
    text: "Available across VMs, containers, and physical servers.",
  },
];
